<template>
  <footer class="sidebar-footer">
    <span>© {{ currentYear }} - Smiling Gents</span>
    <span>All rights reserved</span>
  </footer>
</template>
<script lang="ts" setup>
import { DateTime } from 'luxon';

const currentYear = DateTime.now().toFormat('y');
</script>
<style lang="scss">
.sidebar-footer {
  padding: 0 32px;
  text-align: center;
  top: auto;
  bottom: 0;
  font-size: 12px;
  font-weight: 400;

  span {
    display: block;
  }
}
</style>
